import * as React from 'react';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createRoot } from 'react-dom/client';

import { AppLanguageProvider } from '@components/app-language-provider';

import App from '@/App.tsx';

const queryClient = new QueryClient();

createRoot(document.getElementById('root')!).render(
	<QueryClientProvider client={queryClient}>
		<AppLanguageProvider>
			<App />
		</AppLanguageProvider>
	</QueryClientProvider>
);
